import React from "react";
import styled from "styled-components";
import { PieChart, Pie, Cell, Tooltip } from "recharts";

import { useRandomColor } from "utils/color";

interface PieChartProps {
  data: {
    name: string;
    value: any;
  }[];
}

export function SimplePieChart({ data = [] }: PieChartProps) {
  return (
    <PieChart width={400} height={400}>
      <Pie
        data={data}
        dataKey="value"
        nameKey="name"
        isAnimationActive={true}
        cx="50%"
        cy="50%"
        outerRadius={80}
        fill="#8884d8"
        label
      />
      <Tooltip />
    </PieChart>
  );
}

export default function ({ data = [] }: PieChartProps) {
  const entries = data.map((entry, index) => ({
    ...entry,
    color: useRandomColor(),
    key: `cell-${index}`,
  }));
  return (
    <Wrapper>
      <PieChart width={300} height={300}>
        <Pie
          data={data}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          label
          outerRadius={80}
          fill="#8884d8"
        >
          {entries.map((entry, index) => (
            <Cell key={entry.key} fill={entry.color} />
          ))}
        </Pie>
      </PieChart>
      <table>
        <tbody>
          {entries.map(({ color, name, value }, index) => {
            return (
              <tr key={`cell-${index}`}>
                <td>
                  <Swatch color={color} />
                </td>
                <td>{name}</td>
                <td>{value}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
`;

const Swatch = styled.div`
  width: 1rem;
  height: 1rem;
  border: 1px solid black;
  background: ${(props) => props.color};
`;
